<template>
  <section class="hero-intro">
    <p class="hello">{{ config.helloText }}</p>
    <h1>
      <span>{{ config.mainTitle }}</span>
      <strong>{{ config.highlightText }}</strong>
    </h1>
    <div class="social-row">
      <a
        v-for="item in socialLinks"
        :key="item.name"
        :href="item.url"
        target="_blank"
        rel="noopener noreferrer"
        :title="item.name"
      >
        <AppIcon :name="item.icon" />
      </a>
    </div>
  </section>
</template>

<script>
import AppIcon from './AppIcon.vue';

export default {
  name: 'HeroIntro',
  components: { AppIcon },
  props: {
    config: {
      type: Object,
      required: true
    },
    socialLinks: {
      type: Array,
      default: () => []
    }
  }
};
</script>
